<template>
  <div
    class="search"
    :style="{ backgroundColor: wrapperBackGround }"
  >
    <div class="flex item-center" >
      <div
        class="search-wrapper flex item-center flex-1"
        :class="{ radius: radius }"
        :style="{
          height: height + 'px',
          backgroundColor: background,
          color: color
        }"
      >
        <span
          class="hmicon search icon-search"
          :style="{
            color: color
          }"
        ></span>
        <input
          readonly
          type="text"
          :placeholder="placeholder"
          :style="{
            height: height + 'px',
            backgroundColor: background,
            color: color
          }"
        />
      </div>
      <div class="scan-wrapper">
        <span
          class="hmicon icon-saoyisao"
          :style="{
            color: color
          }"
        ></span>
      </div>
    </div>
    <div class="hot-search" v-if="hotWordList.length">
        <div class="tag-header">
          热门搜索
          <el-image
            class="hot-logo"
            src="https://imgcdn.hemiao100.com/hemiaoBase/ps653d9daf435b23cd-da17-44ee-8ffd-f85feafdfb73.png"
          ></el-image>
        </div>
        <div class="tag-list tag-list-background" :style="{'background':'url('+versionSrc+')'}">
          <div
            class="tag"            
            @click="setWord(v.word)"
            v-for="(v, i) in hotWordList"
            :key="i"
            :style="{ 'background': v.display==='inline-block' ? v.background : 'none' , 'color': v.color,'display':v.display}"
          >
            {{ v.word }}
            <el-image
            v-if="v.src"
            class="custom"
            :src="v.src"
            ></el-image>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    name: {
      type: String,
      default: "search"
    },
    radius: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    wrapperBackGround: {
      type: String,
      default: "#000"
    },
    hotWordList: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 40
    },
    background: {
      type: String,
      default: "#f0f0f0"
    },
    color: {
      type: String,
      default: "#2B2B2B"
    },
    versionSrc:{
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.search {
  padding: 5px 15px;
  box-sizing: border-box;
  .search-wrapper {
    border-radius: 4px;
    &.radius {
      border-radius: 30px;
      input {
        border-radius: 30px;
      }
    }
    &.flex-center {
      input {
        width: 46px;
      }
    }
    .search {
      color: #666;
      font-size: 16px;
      margin-left: 10px;
    }
    input {
      border: none;
      height: 100%;
      width: 100%;
      padding: 0 20px;
      font-size: 14px;
      &:focus {
        outline: none;
      }
    }
  }
  .scan-wrapper {
    padding-left: 15px;
  }
}
.hot-search {
  margin-top: 17px;
}
.hot-search {
  margin-top: 17px;
}
.tag-list {
  margin-top:17px;
  .tag {
    display: inline-block;
    margin-right: 10px;
    padding: 4px 15px;
    border-radius: 30px;
    margin-bottom: 15px;
    .custom{
      width: 13px;
      height: 13px;
      margin-left: 5px;
    }
  }
}
.tag-list-background{
  min-height: 190px;
  background-size:345px 190px;
  background-repeat: no-repeat;
}
.hot-logo {
    width: 32px;
    height: 15px;
    margin-left: 5px;
  }
</style>
